module.exports = __webpack_public_path__ + "static/media/gift_4.dd93b17f.png";